import React, { useState, useEffect } from 'react';
import ChatBot from 'react-simple-chatbot';
import CloseIcon from '@mui/icons-material/Close';
import HeadsetIcon from '@mui/icons-material/Headset';
import { axiosApi } from '../../_helper/api_helper';
import LoadingPannel from '../../commonComponent/LoadingPannel/LoadingPannel';
import "./chatboxindex.scss"
import { useNavigate } from 'react-router-dom';

const ChatBotFreelancer = () => {
    const history = useNavigate()

    const client_Id = localStorage.getItem('client_Id');

    const [chatbotOpen, setChatbotOpen] = useState(false);
    const [ticketNumber, setTicketNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false);        

    const toggleChatbot = () => {
        setChatbotOpen(!chatbotOpen);
    };

    const sendRequest = async (subject, message) => {
        const payload = {
            Freelancer: client_Id,
            subject: subject,
            message: message,
        };
        try {
            const response = await axiosApi.post(`/freelancer-tickets/create`, payload);
            return response.data;
        } catch (error) {
            console.error("Error in sendRequest:", error);
            return null;
        }
    };
    const handleNavigateLogin = (item) => {
        if (item == "find-project") {
            history("/all-project-posted")
        }
        if (item == "find-job") {
            history("/hire-talent")
        }
    }

    const handleEnd = async ({ steps, values }) => {
        if (values.includes('yes')) {
            setIsLoading(true);
            const response = await sendRequest(values[1], values[2]);
            setIsLoading(false);

            if (response && response.ticket_number) {
                setShowProcessing(true);
                setTimeout(() => {
                    setTicketNumber(response.ticket_number);
                    setShowProcessing(false);
                }, 60000); // 1 minute delay
            }
        }
    };

    const steps = [
        {
            id: '1',
            message: 'Have a Query?',
            trigger: '2',
        },
        {
            id: '2',
            message: 'Talk to our chatbot, and resolve quickly?',
            trigger: 'userType',
        },
        {
            id: 'userType',
            options: [
                { value: 'yes', label: 'Yes', trigger: 'yes' },
                { value: 'no', label: 'No', trigger: 'no' },
            ],
        },
        {
            id: 'yes',
            message: 'Which type of query you are looking for ?',
            trigger: 'subjectInput',
        },
        {
            id: 'subjectInput',
            user: true,
            trigger: 'messageInputPrompt',
        },
        {
            id: 'messageInputPrompt',
            message: 'Please elaborate your query.',
            trigger: 'messageInput',
        },
        {
            id: 'messageInput',
            user: true,
            trigger: 'endMessage',
        },
        {
            id: 'endMessage',
            message: `Thank you for contacting us. We will get back to you shortly.Your ticket ID number is sent on your email.`,

            end: true,
        },
        {
            id: 'no',
            // message: 'Thanks for chatting. Have a good day!',
            message: 'We are raising your ticket and our RM will contact you shortly.',
            end: true,
        },
    ];

    return (
        <>
            <div className="chatbot-container">
                <div className={`chatbox-home-section  `}>
                    <div className={chatbotOpen ? 'chatbot-open-container' : 'chatbot-inner-section'} >
                        {!chatbotOpen && (
                            <>
                                <div className="login-home-hire-freelancer">
                                    <button onClick={() => handleNavigateLogin("find-project")} >Find Project</button>
                                    <button onClick={() => handleNavigateLogin("find-job")}>Find Jobs</button>
                                </div>

                                <div  onClick={toggleChatbot}  className='headshot-chatbot'>
                                    <img src="/svg/helpsupport.svg" alt="" />
                                    Help
                                </div>
                            </>


                        )}
                        {chatbotOpen && (
                            <div className="chatbot-open-section">
                                <div className="chatbox-icon">
                                    <CloseIcon onClick={toggleChatbot} />
                                </div>
                                <ChatBot
                                    steps={steps}
                                    handleEnd={handleEnd}
                                    opened={true}
                                    toggleFloating={() => { }}
                                    headerTitle="NBF Support"
                                    headerComponent={<div style={{ backgroundColor: 'black', color: 'white', padding: '15px', textAlign: "center" }}>NBF Support</div>}
                                    contentStyle={{ background: '#f5f8fb' }}
                                    bubbleStyle={{ background: 'red', color: 'white' }}
                                    userBubbleStyle={{ background: 'green', color: 'white' }}
                                    bubbleOptionStyle={{ background: 'red', color: 'white' }}
                                />
                            </div>
                        )}
                    </div>

                </div>

            </div>








            
        </>

    );
};

export default ChatBotFreelancer;
